import { useState, useEffect } from "react";

export const useAsyncData = <T,>(dataOrPromise: T | Promise<T>) => {
  const [resolvedData, setResolvedData] = useState<T | null>(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function resolveData() {
      if (dataOrPromise instanceof Promise) {
        setIsLoading(true);
        try {
          const data = await dataOrPromise;
          setResolvedData(data);
          setIsLoading(false);
        } catch (_error) {
          setError(true);
          setIsLoading(false);
          setResolvedData(null);
        }
      } else {
        setResolvedData(dataOrPromise);
        setIsLoading(false);
      }
    }
    resolveData();
  }, [dataOrPromise]);

  if (!(dataOrPromise instanceof Promise)) {
    return { data: dataOrPromise, error: false, isLoading: false };
  }

  return { data: resolvedData, error, isLoading };
};
